export const handleLabelNameChanges = (label: string) => {
  return label
    .replaceAll(' ', '-')
    .replaceAll('(', '')
    .replaceAll(')', '')
    .replaceAll('_', '-')
    .toLowerCase()
}
